import { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { AuthShell, RegisterForm } from "@/pages/_auth";

export default function Register() {
  const { user } = useAuth();
  const navigate = useNavigate();
  useEffect(() => { if (user) navigate("/account"); }, [user, navigate]);
  return (
    <AuthShell title="Create account" subtitle="Free to read. Save bookmarks and keep your place."
      footer={<>Already have an account? <Link to="/login" className="text-indic-gold hover:underline" data-testid="to-login">Sign in</Link></>}>
      <RegisterForm />
    </AuthShell>
  );
}
